import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BASE_PATH } from '../purchase-service/variables';
import {
  PageInfoSalesOrderResultDTO,
  SalesOrderDTO,
  SalesOrderFilter,
  SalesOrderResultDTO,
  SalesOrderStatus,
  SalesOrderUpdateDTO,
} from './models';

/** `SalesOrderController` — `/v1/sales-order`. */
@Injectable({ providedIn: 'root' })
export class SalesOrderApiService {
  private readonly http = inject(HttpClient);
  private readonly basePath = inject(BASE_PATH);

  private get url(): string {
    return `${this.basePath}/v1/sales-order`;
  }

  page(filter: SalesOrderFilter): Observable<PageInfoSalesOrderResultDTO> {
    let params = new HttpParams();
    Object.entries(filter).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params = params.set(key, String(value));
      }
    });
    return this.http.get<PageInfoSalesOrderResultDTO>(this.url, { params });
  }

  getDetail(id: number): Observable<SalesOrderResultDTO> {
    return this.http.get<SalesOrderResultDTO>(`${this.url}/${id}`);
  }

  create(body: SalesOrderDTO): Observable<SalesOrderResultDTO> {
    return this.http.post<SalesOrderResultDTO>(this.url, body);
  }

  update(
    id: number,
    body: SalesOrderUpdateDTO,
  ): Observable<SalesOrderResultDTO> {
    return this.http.put<SalesOrderResultDTO>(`${this.url}/${id}`, body);
  }

  /** PENDING -> APPROVED. */
  approve(id: number): Observable<SalesOrderResultDTO> {
    return this.http.post<SalesOrderResultDTO>(`${this.url}/${id}/approve`, {});
  }

  /** APPROVED -> RELEASED: stock-service creates one outbound per warehouse. */
  release(id: number): Observable<SalesOrderResultDTO> {
    return this.http.post<SalesOrderResultDTO>(`${this.url}/${id}/release`, {});
  }

  /** REJECTED / CANCELLED. */
  updateStatus(
    id: number,
    status: SalesOrderStatus,
  ): Observable<SalesOrderResultDTO> {
    return this.http.put<SalesOrderResultDTO>(`${this.url}/${id}/status`, null, {
      params: new HttpParams().set('status', status),
    });
  }

  delete(id: number): Observable<SalesOrderResultDTO> {
    return this.http.delete<SalesOrderResultDTO>(`${this.url}/${id}`);
  }

  deleteItems(id: number, itemIds: number[]): Observable<SalesOrderResultDTO> {
    return this.http.delete<SalesOrderResultDTO>(
      `${this.url}/${id}/sales-order-item`,
      { params: new HttpParams().set('itemIds', itemIds.join(',')) },
    );
  }
}
